export const TaskPriority = [{
    id: 0,
    name: ''
}, {
    id: 1,
    name: 'Magas'
 }, {
    id: 2,
    name: 'Közepes'
}, {
    id: 3,
    name: 'Alacsony'
}];
